export default __webpack_public_path__ + "static/media/search-small.9069d867.svg";